module.exports = __webpack_public_path__ + "static/media/preys.d5663ec3.jpg";